<template>
    <div class="my-stages w-100 h-100 overflow-auto">
        <div class="d-flex align-items-center px-4 py-3 my-stages-topbar">
            <button type="button" class="icon-btn me-3" @click="$router.push({name: 'MySeasons'})"><i class="bi bi-arrow-left"></i></button>
            <div>
                <div class="my-stages-eyebrow" v-if="season">{{ utils.get_season_label(window_mode) }}</div>
                <div class="my-stages-title">{{ season ? season.name : 'Etapas' }}</div>
            </div>
            <div class="ms-auto d-flex align-items-center">
                <span class="my-stages-user me-2" v-if="$store.state.online_user">{{ $store.state.online_user.username }}</span>
                <button type="button" class="btn btn-sm btn-outline-light" title="Cerrar sesión" @click="logout"><i class="bi bi-box-arrow-left"></i></button>
            </div>
        </div>

        <div class="p-4">
            <div v-if="loading" class="my-stages-empty">
                <span class="spinner-border spinner-border-sm me-2"></span>Cargando...
            </div>
            <div v-else-if="!season" class="my-stages-empty">
                No se ha encontrado esta {{ utils.get_season_label(window_mode).toLowerCase() }}.
            </div>
            <div v-else-if="stages.length == 0" class="my-stages-empty">
                Esta {{ utils.get_season_label(window_mode).toLowerCase() }} todavía no tiene etapas.
            </div>

            <div :class="'stage-card ' + (stage_status(stage) == 'active' ? '' : 'stage-card-disabled')" v-for="stage in stages" :key="stage.id" @click="enter_stage(stage)">
                <div class="stage-card-body">
                    <div class="stage-card-name">{{ stage.name }}</div>
                    <div class="stage-card-dates" v-if="stage.start_date || stage.end_date">{{ format_date(stage.start_date) }} &rarr; {{ format_date(stage.end_date) }}</div>
                </div>
                <span :class="'stage-status status-' + stage_status(stage)">{{ stage_status_label(stage) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '@/../../shared/utils'
import api from '@/api'

export default {
    name: 'MyStages',
    data(){
        return {
            utils: utils,
            window_mode: window.MODE,
            season: null,
            stages: [],
            loading: true,
        };
    },
    computed: {
        season_id(){
            return parseInt(this.$route.params.season_id);
        }
    },
    async created(){
        try{
            const result = await api.stages(this.season_id);
            this.season = result.season;
            this.stages = (result.stages || []).slice().sort((a, b) => a.order - b.order);
        }catch(ex){
            window.toast.error(ex.message || "No se han podido cargar las etapas.");
        }finally{
            this.loading = false;
        }
    },
    methods: {
        format_date(value){
            if(!utils.is_valid_parameter(value))
                return '-';
            return new Date(value).toLocaleDateString();
        },
        // Online mode has no admin manually "forcing" a stage open/closed
        // (started_at/ended_at, used in-person) - here a stage's own
        // start_date/end_date window IS the real gate. Both are optional:
        // an unset bound just doesn't restrict on that side.
        stage_status(stage){
            const now = Date.now();
            if(stage.start_date && now < new Date(stage.start_date).getTime()) return "pending";
            if(stage.end_date && now > new Date(stage.end_date).getTime()) return "done";
            return "active";
        },
        stage_status_label(stage){
            const status = this.stage_status(stage);
            if(status == "pending") return "Próximamente";
            if(status == "done") return "Finalizada";
            return "Activa";
        },
        enter_stage(stage){
            if(this.stage_status(stage) != "active")
                return;
            this.$router.push({name: "StageActivity", params: {stage_id: stage.id}});
        },
        logout(){
            utils.reset_online_client();
        }
    }
}
</script>

<style scoped>
    .my-stages{
        background-color: var(--vc-paper-100);
    }

    .my-stages-topbar{
        background-color: var(--vc-ink-900);
        color: var(--vc-paper-50);
    }

    .my-stages-user{
        font-size: 0.85rem;
        color: rgba(255, 255, 255, 0.7);
    }

    .my-stages-eyebrow{
        font-family: "Archivo", sans-serif;
        font-weight: 700;
        font-size: 0.7rem;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        color: rgba(255, 255, 255, 0.55);
    }

    .my-stages-title{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 1rem;
    }

    .my-stages-empty{
        color: var(--vc-text-600);
        text-align: center;
        padding: 40px 0;
    }

    .icon-btn{
        width: 32px;
        height: 32px;
        flex-shrink: 0;
        border-radius: 6px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background-color: transparent;
        color: var(--vc-paper-50);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .icon-btn:hover{
        background-color: rgba(255, 255, 255, 0.1);
    }

    .stage-card{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        background-color: var(--vc-paper-50);
        border: 1px solid var(--vc-line);
        border-radius: 10px;
        padding: 18px 20px;
        margin-bottom: 12px;
        cursor: pointer;
    }
    .stage-card:hover{
        border-color: var(--vc-accent-500);
    }
    .stage-card-disabled{
        cursor: not-allowed;
        opacity: 0.6;
    }

    .stage-card-name{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 1.05rem;
    }

    .stage-card-dates{
        font-size: 0.8rem;
        color: var(--vc-text-600);
        margin-top: 2px;
    }

    .stage-status{
        display: inline-flex;
        align-items: center;
        font-family: "Archivo", sans-serif;
        font-weight: 700;
        font-size: 0.68rem;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        padding: 0.3em 0.8em;
        border-radius: 999px;
        white-space: nowrap;
        flex-shrink: 0;
    }
    .stage-status.status-active{
        background-color: var(--vc-accent-100);
        color: var(--vc-accent-600);
    }
    .stage-status.status-pending,
    .stage-status.status-done{
        background-color: var(--vc-paper-200);
        color: var(--vc-text-600);
    }
</style>
